import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;
declare var $:any;
@Component({
    templateUrl: './AppViews/Holiday/holiday.html'
})

export class HolidayComponent implements OnInit {
    IsExistsHolidayList: boolean = false;
    IsExistsHolidaySiteMapping: boolean = false;
    IsExistsWeeklyOff: boolean = false;
    ErrorHolidaySiteMapping: string;
    ErrorWeeklyOff: string;
    DatePlusOne: any;
    public jsonParser = JSON;
    public showLoader = false;
    public Holiday: any[] = [];
    public holidayList: any[] = [];
    public country: any[] = [];
    public siteList: any[] = [];
    public weeklyOffList: any[] = [];
    public weeklyOffConfig: any[] = [];
    public constants: Constants;
    public siteId: string = "";
    public countryId: string = "";
    public weeklyOffYearFilter: string = '';
    public holidayYearFilter: string = '';
    public tbWeeklyOffYearFilter: string = '';
    public tbHolidayYearFilter: string = '';
    public isFormSubmitted: boolean = false;
    public isSiteSelected: boolean = true;
    public holidayItem: {
        HolidayId: number,
        HolidayListId: string,
        HolidayName: string,
        CountryId: string,
        SiteId: string,
        HolidayDate: string,
        PrevHolidayListId: number,
        PrevHolidayDate: string
    }
    = {
        HolidayId: 0,
        HolidayListId: null,
        HolidayName: "",
        CountryId: null,
        SiteId: null,
        HolidayDate: "",
        PrevHolidayListId: 0,
        PrevHolidayDate: ""
    };
    public holidayListItem: {
        HolidayListId: number,
        HolidayName: string
    }
    = {
        HolidayListId: 0,
        HolidayName: ""
    }
    public weeklyOffItem: {
        WOFListId: number,
        WOFId: string,
        Year: string,
        SiteId: string,
        PrevYear: string,
        PrevSiteId: string
    }
    = {
        WOFListId: 0,
        WOFId: null,
        Year: '',
        SiteId: '',
        PrevYear: '',
        PrevSiteId: ''
    };
    weeklyOffListofPreviousYear: any[] = [];

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.constants = new Constants();

    }

    ngOnInit() {
        this._httpService.ajaxPost('Common/GetTodaysDate').subscribe(
            data => {
                this.DatePlusOne = data["TodaysDate"];
            },
            err => {
            },
            () => {
                $(".datePicker").datetimepicker({
                    format: 'DD/MM/YYYY',
                    minDate: moment(this.DatePlusOne).add(1, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
                });
                $(".yearPicker").datetimepicker({
                    format: "YYYY",
                    minDate: moment(this.DatePlusOne)
                });

                $(".yearPickerFilter").datetimepicker({
                    format: "YYYY",
                    //useCurrent: true
                    minDate: moment(this.DatePlusOne)
                });

                 this.holidayYearFilter = moment().year().toString();
                this.weeklyOffYearFilter = moment().year().toString();
                this.tbHolidayYearFilter = moment().year().toString();
                this.tbWeeklyOffYearFilter = moment().year().toString();
                this.GetHoliday();
                this.GetHolidayList();
                this.GetWeeklyOffList();
                this.getCountry();
                this.GetSite();
                this.GetWeeklyOffConfig();
            }
        );

        $("#show-filter").click(function () {
            $(".filter-form").slideToggle();
        }).bind(this);
    }

    public getCountry() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["Country"] }).subscribe(
            data => {
                this.country = data["Parameter"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public GetSite() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetSite', null).subscribe(
            data => {
                this.siteList = data["Site"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public GetWeeklyOffConfig() {
        this.showLoader = true;
        this._httpService.ajaxPost('Holiday/GetWeeklyOffConfig', null).subscribe(
            data => {
                this.weeklyOffConfig = data["WeeklyOffConfig"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public GetHoliday() {
        this.showLoader = true;
        this._httpService.ajaxPost('Holiday/GetHoliday', { "SiteId": this.siteId, "CountryId": this.countryId }).subscribe(
            data => {
                this.DatePlusOne = data["DatePlusOne"];
                this.Holiday = data["Holiday"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public AddUpdateHoliday(form: any) {
        this.isFormSubmitted = true;
        this.IsExistsHolidaySiteMapping = false;

        this.holidayItem.SiteId = "";
        for (var i = 0; i < this.siteList.length; i++) {
            var item = this.siteList[i];
            if (item.IsSelected) {
                this.holidayItem.SiteId += item.SiteId + ",";
            }
        }
        this.holidayItem.SiteId = this.holidayItem.SiteId.slice(0, -1);
        if (form.form.valid) {
            if (this.holidayItem.SiteId.length > 0) {
                this.showLoader = true;
                this.holidayItem.CountryId = "0";
                this._httpService.ajaxPost('Holiday/AddUpdateHoliday', this.holidayItem).subscribe(
                    data => {
                        var message = data["Status"].Message.split('|');
                        if (message[0].toLowerCase() == "success") {
                            $('#btnHoliday').trigger('click');
                            this.GetHoliday();
                        }
                        if (message[0].toLowerCase() == "warning" || message[0].toLowerCase() == "error") {
                            this.ErrorHolidaySiteMapping = message[1];
                            this.IsExistsHolidaySiteMapping = true;
                        }
                        else {
                            this._sharedService.ShowMessage(data["Status"].Message);
                        }
                    },
                    err => {
                        this.showLoader = false;
                        this._sharedService.ShowMessage(this.constants.globalError);
                    },
                    () => {
                        this.showLoader = false;
                    }
                );
            }
            else {
                this.isSiteSelected = false;
            }
        }
        else {
            if (this.holidayItem.SiteId.length == 0) {
                this.isSiteSelected = false;
            }
        }
    }

    public EditHoliday(item: any) {
        this.IsExistsHolidaySiteMapping = false;
        this.holidayItem.HolidayId = item.HolidayId;
        this.holidayItem.HolidayDate = item.HolidayDate;
        this.holidayItem.HolidayListId = item.HolidayListId;
        this.holidayItem.CountryId = item.CountryId;
        this.holidayItem.SiteId = item.SiteDetail;
        this.holidayItem.HolidayName = item.HolidayName;
        this.holidayItem.PrevHolidayListId = item.HolidayListId;
        this.holidayItem.PrevHolidayDate = item.HolidayDate;

        this.siteList.forEach(function (item) {
            item.IsSelected = false;
        });

        var siteIdList: any[] = (item.SiteDetail != null) ? JSON.parse(item.SiteDetail) : [];
        for (var siteIndex = 0; siteIndex < this.siteList.length; siteIndex++) {
            var item = this.siteList[siteIndex];
            for (var index = 0; index < siteIdList.length; index++) {
                var element = siteIdList[index];
                if (element.SiteId == item.SiteId) {
                    item.IsSelected = true;
                }
            }
        }

    }

    public ResetHolidayForm(form: any) {
        form.reset();
        form.resetForm();
        this.holidayItem.HolidayId = 0;
        this.holidayItem.HolidayListId = "";
        this.holidayItem.CountryId = "";
        this.holidayItem.SiteId = "";
        this.holidayItem.PrevHolidayListId = 0;
        this.holidayItem.PrevHolidayDate = "";
        this.siteList.forEach(function (item) {
            item.IsSelected = false;
        });
        this.isFormSubmitted = false;
        this.isSiteSelected = true;
        this.IsExistsHolidaySiteMapping = false;
    }

    public GetHolidayList() {
        this.showLoader = true;
        this._httpService.ajaxPost('Holiday/GetHolidayList', null).subscribe(
            data => {
                this.holidayList = data["HolidayList"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public AddUpdateHolidayList(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.showLoader = true;
            this.IsExistsHolidayList = false;
            this.holidayList.forEach(element => {
                if (element.HolidayName == this.holidayListItem.HolidayName) {
                    this.IsExistsHolidayList = true;
                }
            });
            if (this.IsExistsHolidayList) { this.showLoader = false; return; }

            this._httpService.ajaxPost('Holiday/AddUpdateHolidayList', this.holidayListItem).subscribe(
                data => {
                    var message = data["Status"].Message.split('|');
                    if (message[0].toLowerCase() == "success") {
                        $('#btnHolidayList').trigger('click');
                        this.GetHolidayList();
                    }
                    this._sharedService.ShowMessage(data["Status"].Message);
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },
                () => {
                    this.showLoader = false;
                }
            );
        }
    }

    public EditHolidayList(item: any) {
        this.IsExistsHolidayList = false;
        this.holidayListItem.HolidayListId = item.HolidayListId;
        this.holidayListItem.HolidayName = item.HolidayName;
    }

    public ResetHolidayListForm(form: any) {
        form.reset();
        form.resetForm();
        this.holidayListItem.HolidayListId = 0;
        this.isFormSubmitted = false;
        this.IsExistsHolidayList = false;
    }

    public GetWeeklyOffList() {
        this.showLoader = true;
        this._httpService.ajaxPost('Holiday/GetWeeklyOffList', { "Year": 0 }).subscribe(
            data => {
                this.weeklyOffList = data["WeeklyOffList"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public AddUpdateWeeklyOffList(form: any) {
        this.isFormSubmitted = true;
        this.weeklyOffItem.SiteId = "";
        for (var i = 0; i < this.siteList.length; i++) {
            var item = this.siteList[i];
            if (item.IsSelected) {
                this.weeklyOffItem.SiteId += item.SiteId + ",";
            }
        }
        this.weeklyOffItem.SiteId = this.weeklyOffItem.SiteId.slice(0, -1);
        if (form.form.valid) {
            if (this.weeklyOffItem.SiteId.length > 0) {
                this.showLoader = true;
                this._httpService.ajaxPost('Holiday/AddUpdateWeeklyOffList', this.weeklyOffItem).subscribe(
                    data => {
                        var message = data["Status"].Message.split('|');
                        if (message[0].toLowerCase() == "success") {
                            $('#btnWeeklyOffList').trigger('click');
                            this.GetWeeklyOffList();
                        }
                        if (message[0].toLowerCase() == "warning" || message[0].toLowerCase() == "error") {
                            this.ErrorWeeklyOff = message[1];
                            this.IsExistsWeeklyOff = true;
                        }
                        else {
                            this._sharedService.ShowMessage(data["Status"].Message);
                        }
                    },
                    err => {
                        this.showLoader = false;
                        this._sharedService.ShowMessage(this.constants.globalError);
                    },
                    () => {
                        this.showLoader = false;
                    }
                );
            }
            else {
                this.isSiteSelected = false;
            }
        }
        else {
            if (this.weeklyOffItem.SiteId.length == 0) {
                this.isSiteSelected = false;
            }
        }
    }

    public EditWeeklyOffList(item: any) {
        this.IsExistsWeeklyOff = false;
        this.weeklyOffItem.WOFListId = item.WOFListId;
        this.weeklyOffItem.Year = item.Year;
        this.weeklyOffItem.WOFId = item.WOFId;
        this.weeklyOffItem.PrevYear = item.Year;
        this.weeklyOffItem.PrevSiteId = item.SiteDetail

        this.siteList.forEach(function (item) {
            item.IsSelected = false;
        });

        var siteIdList: any[] = (item.SiteDetail != null) ? JSON.parse(item.SiteDetail) : [];
        for (var siteIndex = 0; siteIndex < this.siteList.length; siteIndex++) {
            var item = this.siteList[siteIndex];
            for (var index = 0; index < siteIdList.length; index++) {
                var element = siteIdList[index];
                if (element.SiteId == item.SiteId) {
                    item.IsSelected = true;
                }
            }
        }
    }

    public ResetWeeklyOffForm(form: any) {
        form.reset();
        form.resetForm();
        this.weeklyOffItem.WOFListId = 0;
        this.weeklyOffItem.Year = "";
        this.weeklyOffItem.WOFId = "";
        this.weeklyOffItem.SiteId = "";
        this.siteList.forEach(function (item) {
            item.IsSelected = false;
        });
        this.isFormSubmitted = false;
        this.isSiteSelected = true;
    }

    public ClearFilter() {

    }
    ExportHolidayItems() {
        this.showLoader = true;
        this._httpService.ajaxPost('Holiday/ExportHolidaySiteMapping', { "Year": this.holidayYearFilter }).subscribe(
            data => {
                var exportData = data["HolidaySiteMappingList"];
                ExportToExcel(exportData, "HolidaySiteMapping",
                    ["Year", "DayOfWeek", "HolidayDate", "HolidayName", "SiteName"],
                    ["Year", "DayOfWeek", "Holiday Date", "Holiday Name", "Site Name"]);
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    ExportHolidayListItems() {
        ExportToExcel(this.holidayList, "Holiday",
            ["HolidayName"],
            ["Holiday Name"]);
    }


    ResetCopyWeeklyOffForm() {

         this.showLoader = true;
            this._httpService.ajaxPost('Holiday/GetWeeklyOffListofPreviousYear', { "Year": this.tbWeeklyOffYearFilter }).subscribe(
                data => {
                    debugger
                    this.weeklyOffListofPreviousYear = data["WeeklyOffListofPreviousYear"];
                    this.weeklyOffListofPreviousYear.forEach(element => {
                        element.IsSelected = false
                  });

                    $('#copyweeklyOffConfig').modal('show');
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },
                () => {
                    this.showLoader = false;
                }
            );



    }
    CopyWeeklyOffList(){
        // this.isFormSubmitted = true;
        // this.weeklyOffItem.SiteId = "";
        // for (var i = 0; i < this.siteList.length; i++) {
        //     var item = this.siteList[i];
        //     if (item.IsSelected) {
        //         this.weeklyOffItem.SiteId += item.SiteId + ",";
        //     }
        // }
        // this.weeklyOffItem.SiteId = this.weeklyOffItem.SiteId.slice(0, -1);


       var weeklyOffList =  this.weeklyOffListofPreviousYear.filter(element => element.IsSelected == true) ;


               this.showLoader = true;
                this._httpService.ajaxPost('Holiday/CopyWeeklyOffList', { "Year" :this.tbWeeklyOffYearFilter,"weeklyOffListofPreviousYear":weeklyOffList }).subscribe(
                    data => {
                        var message = data["Status"].Message.split('|');
                        if (message[0].toLowerCase() == "success") {
                            $('#copyweeklyOffConfig').modal('hide');
                            this.GetWeeklyOffList();
                        }

                        else {
                            this._sharedService.ShowMessage(data["Status"].Message);
                        }
                    },
                    err => {
                        this.showLoader = false;
                        this._sharedService.ShowMessage(this.constants.globalError);
                    },
                    () => {
                        this.showLoader = false;
                    }
                );
            }


}



/** WEBPACK FOOTER **
 ** ./TypeScripts/Holiday/holiday.component.ts
 **/